// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P81Z","field":"styles_field__27yNZ","fieldCol":"styles_fieldCol__2FMlV","diffCol":"styles_diffCol__3pQLz","diff":"styles_diff__1vO3D"};